export default function(data) {
var __t, __p = '';
__p += 'Expires <span class="' +
((__t = ( this.expiringSoonClass() )) == null ? '' : __t) +
'">' +
((__t = ( this.formattedExpiration() )) == null ? '' : __t) +
'</span>\n';
return __p
}